var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/require-default-props */
import { defineMessages, useIntl } from 'react-intl';
import { useState, useEffect } from 'react';
import api from '@/shared/api';
import config from '@/config';
import MultiSelect, { addItem, removeItem, splitItems } from './MultiSelect';
import guid from '@/shared/utils/guid';
import { dynamicSort } from '@/shared/utils/dynamicSort';
var messages = defineMessages({
    WithoutRelationGroup: {
        id: 'WithoutRelationGroup',
        defaultMessage: 'Without relation group',
    },
    RelationGroups: {
        id: 'RelationGroups',
        defaultMessage: 'Relation groups',
    },
});
var RelationGroupMultiSelect = function (_a) {
    var selection = _a.selection, placeholder = _a.placeholder, onChange = _a.onChange;
    var _b = useState([]), items = _b[0], setItems = _b[1];
    var intl = useIntl();
    useEffect(function () {
        var cancelled = false;
        api.base.get("".concat(config.appUrls.api, "/api/RelationGroup/GetAll")).then(function (_a) {
            var data = _a.data;
            setItems(__spreadArray([
                { id: guid.empty, label: intl.formatMessage(messages.WithoutRelationGroup) }
            ], (data !== null && data !== void 0 ? data : []).map(function (x) { return ({ id: x.id, label: x.name }); }).sort(dynamicSort('label')), true));
        });
        return function () {
            cancelled = true;
        };
    }, [intl]);
    var _c = splitItems(items, selection), selectedItems = _c[0], selectableItems = _c[1];
    return (_jsx(MultiSelect, { selectedItem: selectedItems, onItemRemoved: function (item) { return onChange(removeItem(selection, item)); }, onItemSelected: function (item) { return onChange(addItem(selection, item)); }, items: selectableItems, placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : intl.formatMessage(messages.RelationGroups) }));
};
export default RelationGroupMultiSelect;
